import { FilterConditionOutput } from '@shared/components/ui/AdvancedFilter';
import { FiltersDropdown } from '@shared/components/ui/FiltersDropdown';
import { Search } from '@shared/components/ui/Search';
import { ColumnSelector } from '@shared/components/ui/ColumnSelector';
import { ChangeEvent, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DownloadExcelButton } from './DownloadExcelButton';
import { ProductsFiltersPanel } from './ProductsFiltersPanel';

interface FiltersSectionProps {
  handleSearch: (value: string) => void;
  onFilterChange?: (conditions: FilterConditionOutput[]) => void;
  allColumns: any[];
  selectedColumns: string[];
  onColumnsChange: (columns: string[]) => void;
  fixedColumns?: string[];
  exportColumns: string[];
  hasTeamData?: boolean;
  searchTerm: string;
  filterConditions: FilterConditionOutput[];
}

export const FiltersSection = ({
  handleSearch,
  onFilterChange,
  allColumns,
  selectedColumns,
  onColumnsChange,
  fixedColumns = [],
  exportColumns,
  hasTeamData = false,
  searchTerm,
  filterConditions,
}: FiltersSectionProps) => {
  const { t } = useTranslation('productsModule');
  const [inputValue, setInputValue] = useState(searchTerm);

  useEffect(() => {
    setInputValue((prev) => (prev === searchTerm ? prev : searchTerm));
  }, [searchTerm]);

  const activeFiltersCount = useMemo(() => {
    return filterConditions.length;
  }, [filterConditions]);

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  };

  const handleSearchSubmit = () => {
    handleSearch(inputValue.trim());
  };

  return (
    <>
      <Search
        placeholder={t('search.placeholder')}
        value={inputValue}
        onChange={handleInputChange}
        onEnter={handleSearchSubmit}
        dataTestId="search"
        inputDataTestId="search-input"
      />

      <FiltersDropdown
        title={t('filters.title', 'Filtros')}
        activeFiltersCount={activeFiltersCount}
        triggerTestId="filters-toggle-button"
      >
        <ProductsFiltersPanel
          initialConditions={filterConditions}
          onChange={onFilterChange}
          hasTeamData={hasTeamData}
        />
      </FiltersDropdown>

      <ColumnSelector
        columns={allColumns}
        selected={selectedColumns}
        onColumnsChange={onColumnsChange}
        fixedColumns={fixedColumns}
        storageKey="products-list"
        dataTestId="products-column-selector"
      />
      <DownloadExcelButton filters={{ columns: exportColumns }} />
    </>
  );
};
